module.exports = __webpack_public_path__ + "media/images/swipe-18659438f705251ffbdfc79d3fa1908b.gif";